import { Injectable } from '@angular/core';

interface ByGraph{
  ton: {
    label:string,
    backgroundColor:string, 
    data:number[]
  }[],
  utility: {
    label:string, 
    backgroundColor:string,
    data:number[]
  }[],
  gas: {
    label:string, 
    backgroundColor:string,
    data:number[]
  }[],
  expenses: {
    label:string, 
    backgroundColor:string,
    data:number[]
  }[],
  market: {
    label:string, 
    backgroundColor:string,
    data:number[]
  }[],
}

@Injectable({
  providedIn: 'root'
})
export class DashboardManager {

  private data:any = [];

  labels:string[] = [];
  datasets:ByGraph;
  private colors:string[] = [
    'rgb(220, 20, 60)',
    'rgb(255, 20, 147)',
    'rgb(255, 140, 0)',
    'rgb(255, 215, 0)',
    'rgb(255, 0, 255)',
    'rgb(139, 0, 139)',
    'rgb(34, 139, 34)',
    'rgb(30, 144, 255)',
    'rgb(123, 104, 238)',
    'rgb(139, 69, 19)',
    'rgb(0, 128, 128)',
    'rgb(112, 128, 144)',
  ];

  constructor() { }

  setData(data) {
    this.data = data;
  }

  getTotals() {
    let monthsObjArr:ByGraph = {
      ton: [],
      expenses: [],
      gas: [],
      market: [],
      utility: [],
    };
    let labels:string[] = [];
    let dataTmp:number[] = [];

    for (let key in this.data) {
      if (key != 'Otro') {
        labels.push(key);
        dataTmp.push(0);
      }
    }

    for (let key in this.data) {
      if (key != 'Otro') {
        let travels = this.data[key].travels;
  
        for (let i = 0; i < travels.length; i++) {
          let travel = travels[i];
          let dt = travel.date.substring(0, 7);
          let singleMonth = monthsObjArr.ton.find(m => m.label == dt);
  
          if (!singleMonth) {
            let color = this.getColor(dt);
            monthsObjArr.ton.push({label: dt, data: dataTmp.slice(0), backgroundColor: color});
            monthsObjArr.expenses.push({label: dt, data: dataTmp.slice(0), backgroundColor: color});
            monthsObjArr.gas.push({label: dt, data: dataTmp.slice(0), backgroundColor: color});
            monthsObjArr.market.push({label: dt, data: dataTmp.slice(0), backgroundColor: color});
            monthsObjArr.utility.push({label: dt, data: dataTmp.slice(0), backgroundColor: color});
  
            monthsObjArr.ton[0].data[labels.indexOf(key)] = Number(travel.ton);
            monthsObjArr.expenses[0].data[labels.indexOf(key)] = Number(travel.total_expenses);
            monthsObjArr.gas[0].data[labels.indexOf(key)] = Number(travel.lts);
            monthsObjArr.market[0].data[labels.indexOf(key)] = Number(travel.market_price);
            monthsObjArr.utility[0].data[labels.indexOf(key)] = Number(travel.profit);
          } else {
            singleMonth.data[labels.indexOf(key)] += Number(travel.ton);
            monthsObjArr.expenses.find(m => m.label == dt).data[labels.indexOf(key)] += Number(travel.total_expenses);
            monthsObjArr.gas.find(m => m.label == dt).data[labels.indexOf(key)] += Number(travel.lts);
            monthsObjArr.market.find(m => m.label == dt).data[labels.indexOf(key)] += Number(travel.market_price);
            monthsObjArr.utility.find(m => m.label == dt).data[labels.indexOf(key)] += Number(travel.profit);
          }
        }
      }
    }

    for (let key in monthsObjArr) {
      for (let i = 0; i < monthsObjArr[key].length; i++) {
        for (let j = 0; j < monthsObjArr[key][i].data.length; j++) {
          monthsObjArr[key][i].data[j] = Math.round(monthsObjArr[key][i].data[j] * 100) / 100;
        }
      }
    }

    this.labels = labels;
    this.datasets = monthsObjArr;
  }

  private getColor(dt:string) : string {
    return this.colors[Number(dt.substring(5)) - 1];
  }
}
